// Firebase Cloud Messaging Configuration File.
// Read more at https://firebase.google.com/docs/cloud-messaging/js/client && https://firebase.google.com/docs/cloud-messaging/js/receive

import { initializeApp } from "@firebase/app";
import { getMessaging, getToken, onMessage, isSupported } from "@firebase/messaging";

var firebaseConfig = {
  apiKey: "AIzaSyDOg-x942QO_VNXeAOQDTVruYPrjTr4qsA",
  authDomain: "hit-fit-5eac2.firebaseapp.com",
  projectId: "hit-fit-5eac2",
  storageBucket: "hit-fit-5eac2.appspot.com", // Fix typo: `.app` should be `.com`
  messagingSenderId: "268816991166",
  appId: "1:268816991166:web:67ba1ccabff3855e1fefef",
  measurementId: "G-ZQ41JCJ7VN",
};

const firebase = initializeApp(firebaseConfig);
console.log(firebase);

// getMessaging() throws synchronously in environments that don't support the Firebase
// Messaging APIs (some browsers, private/incognito modes, blocked service workers) — since this
// file is imported at app startup, an unguarded throw here used to crash the entire app before
// anything rendered. isSupported() + a try/catch keep that failure contained to "no push
// notifications this session" instead.
let messaging = null;
isSupported()
  .then((supported) => {
    if (supported) {
      try {
        messaging = getMessaging();
      } catch (err) {
        console.error("Failed to initialize Firebase Messaging:", err);
      }
    }
  })
  .catch((err) => {
    console.error("Firebase Messaging support check failed:", err);
  });

// let userUid = null;

// onAuthStateChanged(auth, (user) => {
//   if (user) {
//     userUid = user.uid; // Get the UID
//     console.log("User UID: ", userUid);
//   } else {
//     console.log("No user is signed in.");
//   }
// });

export const requestForToken = async () => {
  if (!messaging) {
    return;
  }
  try {
    const currentToken = await getToken(messaging, {
      vapidKey: `BJEU_5R_zbMc3wzCzOn66I_hNbdU_UOiZyoat8Ps6a5SpgXQay77zGqDce6NvHrMIMJAPrK0oRO9rBFbuMVEDjc`,
    });

    if (currentToken) {
      localStorage.setItem("fcm_token", currentToken);
    } else {
      console.log(
        "No registration token available. Request permission to generate one."
      );
    }
  } catch (err) {
    // Not a real failure — this is caught deliberately so a denied/blocked notification
    // permission (very common: e.g. every automated test browser, or a user who just said "no")
    // never breaks anything that calls requestForToken() (Login's onLogin, in particular).
    // console.warn (not .error) so it doesn't read as a real error in the browser console or in
    // tooling that surfaces console.error calls as failures (e.g. Playwright's UI Mode).
    console.warn("Push notification token unavailable: ", err);
  }
};

// `navigator.serviceWorker` only exists in a secure context (https:// or http://localhost) —
// opening the app over plain HTTP via a LAN IP (e.g. http://192.168.1.15:3002) is not one, so
// this was `undefined` and `.register` threw synchronously at import time, crashing the whole
// app before anything rendered. Guard it the same way the Messaging support check above does:
// no push notifications this session instead of no app at all.
if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      localStorage.setItem(
        "firebase",
        JSON.stringify({ scope: registration.scope })
      );
      console.log("firebase-messaging registered:", registration);
    })
    .catch((err) => {
      localStorage.setItem("firebase", "Firebase not set");
      console.error("firebase-messaging registration failed:", err);
    });
} else {
  console.warn(
    "navigator.serviceWorker unavailable (insecure context — not https:// or localhost); push notifications disabled this session."
  );
}

export const onMessageListener = () =>
  new Promise((resolve) => {
    if (!messaging) {
      return;
    }
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
  });
